import { itwApi } from '@application/api/middlewares/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
export const addCanvasFrameAndPolygon = createAsyncThunk('canvas/addCanvasFrameAndPolygon', async (frame, { rejectWithValue }) => {
    try {
        const payload = { frame };
        const res = await itwApi.post('/Canvas/add-canvas-frame-and-polygon', payload, { headers: { 'Content-Type': 'application/json' } });
        return res.data;
    }
    catch (error) {
        return rejectWithValue(error?.response?.data?.message ??
            error?.response?.data?.title ??
            'Failed to add canvas frame and polygon');
    }
});
export const getCanvasFrameAndPolygon = createAsyncThunk('canvas/getCanvasFrameAndPolygon', async (systemId, { rejectWithValue }) => {
    try {
        const res = await itwApi.get('/Canvas/get-canvas-frame-and-polygon', {
            params: { systemId }
        });
        return res.data;
    }
    catch (error) {
        return rejectWithValue(error?.response?.data?.message ??
            error?.response?.data?.title ??
            'Failed to get canvas frame and polygon');
    }
});
export const deleteCanvasPolygon = createAsyncThunk('canvas/deleteCanvasFrameAndPolygon', async (polygonId, { rejectWithValue }) => {
    try {
        const res = await itwApi.delete('/Canvas/delete-canvas-polygon', {
            params: { polygonId }
        });
        return res.data;
    }
    catch (error) {
        return rejectWithValue(error?.response?.data?.message ??
            error?.response?.data?.title ??
            'Failed to delete canvas frame and polygon');
    }
});
export const updateCanvasPolygon = createAsyncThunk('canvas/updateCanvasPolygon', async (command, { rejectWithValue }) => {
    try {
        const res = await itwApi.put('/Canvas/update-canvas-polygon', command);
        return res.data;
    }
    catch (error) {
        return rejectWithValue(error?.response?.data?.message ??
            error?.response?.data?.title ??
            'Failed to update canvas polygon');
    }
});
